import React, { useState } from 'react';
import { Row, Col, Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import EditBillingInfoModal from './edit-modal.js';
import useStyles from '../../style.js';

const InvoiceBillingInfo = ({ landlord, getLandlord, updateLandlord }) => {
  const { billingCity, billingCountry, billingAddress, billingPostalCode } = landlord;

  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const classes = useStyles();

  return (
    <>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            title={t('cms.landlord.invoice_info.title.billing_info')}
            extra={
              <span
                className={classes.formOutLineIcon}
                onClick={() => {
                  setVisible(true);
                }}
              >
                {t('cms.sepcial_offer.edit.btn')}
              </span>
            }
            className={classes.cardWrapper}
          >
            <Descriptions column={1} className={classes.descriptionWrapper}>
              <Descriptions.Item label={t('cms.landlord.modal.edit_billing_info.billing_name')}>
                {billingCity?.name}
              </Descriptions.Item>
              <Descriptions.Item label={t('cms.landlord.modal.edit_billing_info.billing_country')}>
                {billingCountry?.name}
              </Descriptions.Item>
              <Descriptions.Item label={t('cms.landlord.invoice_info.billing_info.address_label')}>
                {billingAddress}
              </Descriptions.Item>
              <Descriptions.Item label={t(`cms.landlord.invoice_info.billing_info.zip_code_label`)}>
                {billingPostalCode}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
      <EditBillingInfoModal
        landlord={landlord}
        getLandlord={getLandlord}
        updateLandlord={updateLandlord}
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </>
  );
};

InvoiceBillingInfo.propTypes = {
  landlord: PropTypes.object.isRequired,
  getLandlord: PropTypes.func.isRequired,
  updateLandlord: PropTypes.func.isRequired,
};

export default InvoiceBillingInfo;
